export const STORE_REPORT_DATA = 'STORE_REPORT_DATA';
export const STORE_REPORT_ID = 'STORE_REPORT_ID';
export const STORE_REPORT_TYPE = 'STORE_REPORT_TYPE';
export const STORE_DASHBOARD_REPORT_STATUS = 'STORE_DASHBOARD_REPORT_STATUS';
